export default __webpack_public_path__ + "static/media/bottomBread.8b616927.png";